import React from 'react';
import './check.scss';

function Radio({ label, handleChange, value, name, checked }) {
  return (
    <div className="radio-check">
      <input
        className="radio-check-input"
        name={name}
        id={name}
        value={value}
        onChange={handleChange}
        type="radio"
        checked={checked || value}
      />
      <label className="radio-check-label heading-sm" htmlFor={name}>
        {label}
      </label>
    </div>
  );
}

export default Radio;
